import React, { createContext, useContext, useState, ReactNode } from 'react';

type AccountFilterType = 'all' | 'personal' | 'business';

interface AccountFilterContextType {
  accountFilter: AccountFilterType;
  setAccountFilter: (filter: AccountFilterType) => void;
}

const AccountFilterContext = createContext<AccountFilterContextType | undefined>(undefined);

interface AccountFilterProviderProps {
  children: ReactNode;
}

export const AccountFilterProvider: React.FC<AccountFilterProviderProps> = ({ children }) => {
  const [accountFilter, setAccountFilter] = useState<AccountFilterType>('all');

  return (
    <AccountFilterContext.Provider value={{ accountFilter, setAccountFilter }}>
      {children}
    </AccountFilterContext.Provider>
  );
};

export const useAccountFilter = (): AccountFilterContextType => {
  const context = useContext(AccountFilterContext);
  if (context === undefined) {
    throw new Error('useAccountFilter must be used within an AccountFilterProvider');
  }
  return context;
};
